import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { baseurl } from '../utility/helper';
import Swal from 'sweetalert2';

const FeesPage = () => {
  const [feesType, setFeesType] = useState('');
  const [feesAmount, setFeesAmount] = useState('');
  const [feesList, setFeesList] = useState([]);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    fetchFees();
  }, []);

  const fetchFees = async () => {
    try {
      const response = await axios.get(`${baseurl}/admin/getFees`);
      const activeFees = response.data;
      setFeesList(activeFees);
    } catch (error) {
      console.error("Error fetching fees:", error);
      alert("Failed to fetch fees.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (feesType.trim() === '' || feesAmount.trim() === '') {
      alert("Both fields are required.");
      return;
    }

    const updatedFee = {
      type: feesType,
      amount: feesAmount
    };

    try {
      await axios.put(`${baseurl}/admin/updateFee/${editId}`, updatedFee);
      Swal.fire("Updated!", "Fee has been updated.", "success");
      setEditId(null);
      setFeesType('');
      setFeesAmount('');
      fetchFees();
    } catch (error) {
      console.error("Error updating fee:", error);
      Swal.fire("Error", "Failed to update fee.", "error");
    }
  };

  const handleEdit = (fee) => {
    setFeesType(fee.type);
    setFeesAmount(fee.fees);
    setEditId(fee.fee_id);
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete this fee entry.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel"
    });

    if (confirm.isConfirmed) {
      try {
        await axios.put(`${baseurl}/admin/deleteFee/${id}`);
        Swal.fire("Deleted!", "Fee has been removed.", "success");
        fetchFees();
      } catch (error) {
        console.error("Error deleting fee:", error);
        Swal.fire("Error!", "Failed to delete fee.", "error");
      }
    }
  };

  return (
    <div className="content container-fluid">
      <div className="profile-section">
        <div className="container mt-4">

          {/* Show form ONLY when editing */}
          {editId && (
            <div>
              <h2>Edit Fee</h2>
              <form onSubmit={handleSubmit} className="mb-4">
                <div className="form-group mb-3">
                  <label>Fees Type</label>
                  <input
                    type="text"
                    className="form-control"
                    value={feesType}
                    onChange={(e) => setFeesType(e.target.value)}
                    placeholder="Enter fee type"
                    disabled
                  />
                </div>
                <div className="form-group mb-3">
                  <label>Fees Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    value={feesAmount}
                    onChange={(e) => setFeesAmount(e.target.value)}
                    placeholder="Enter amount"
                  />
                </div>
                <button type="submit" style={{ borderRadius: '8px' }}>
                  Update
                </button>
                <button
                  type="button"
                  className="btn btn-secondary ms-2"
                  onClick={() => {
                    setEditId(null);
                    setFeesType('');
                    setFeesAmount('');
                  }}
                >
                  Cancel
                </button>
              </form>
            </div>
          )}

          {feesList.length > 0 && (
            <div>
              <center><h4>Fees List</h4></center>
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Fees Type</th>
                    <th>Amount</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {feesList.map((fee, index) => (
                    <tr key={fee.fee_id}>
                      <td>{index + 1}</td>
                      <td>{fee.type}</td>
                      <td>{fee.fees}</td>
                      <td>
                        <button
                          className="btn btn-warning btn-sm me-2"
                          onClick={() => handleEdit(fee)}
                        >
                          <i className="fas fa-edit"></i> Edit
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(fee.fee_id)}
                        >
                          <i className="fas fa-trash"></i> Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeesPage;
